import { render, staticRenderFns } from "./k-actions.vue?vue&type=template&id=3a4a39aa&lang=pug&"
import script from "./k-actions.vue?vue&type=script&lang=js&"
export * from "./k-actions.vue?vue&type=script&lang=js&"
import style0 from "./k-actions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4a39aa')) {
      api.createRecord('3a4a39aa', component.options)
    } else {
      api.reload('3a4a39aa', component.options)
    }
    module.hot.accept("./k-actions.vue?vue&type=template&id=3a4a39aa&lang=pug&", function () {
      api.rerender('3a4a39aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-actions.vue"
export default component.exports